import React from 'react';
import { createRoot } from 'react-dom/client';
import CaptchaAudioButton from './CaptchaAudioButton';
import type {
  CaptchaAudioButtonProps,
  CaptchaAudioButtonHandle,
} from './types';

declare global {
  interface Window {
    mountCaptchaAudioButton: (
      containerId: string,
      props?: CaptchaAudioButtonProps,
    ) => CaptchaAudioButtonHandle;
  }
}

window.mountCaptchaAudioButton = function mountCaptchaAudioButton(
  containerId: string,
  props: CaptchaAudioButtonProps = {},
): CaptchaAudioButtonHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('CaptchaAudioButton: container not found:', containerId);
    return { type: 'captcha-audio-button', unmount: () => {} };
  }

  const root = createRoot(container);
  root.render(React.createElement(CaptchaAudioButton, props));

  return {
    type: 'captcha-audio-button',
    unmount: () => root.unmount(),
  };
};

export type {
  CaptchaAudioButtonProps,
  CaptchaAudioButtonHandle,
};
